module.exports = __webpack_public_path__ + "static/img/consumption.2464f384.svg";